import React, { useContext, useEffect, useRef, useState } from "react";
import { globalActionsTypes, useSessionHook } from "../hooks";
import { GlobalContext, Il8Context } from "../contexts";
import { AlertPopup, BackCard, CountryInp, Layout, LookUp, ProductBlueBtn, T, countryValidation, postCodeValidation, streetValidation, townValidation } from "../components";
import { callApi } from "../services";

function ShippingAddress() {

const sessionHelpers = useSessionHook();
  const { token } = sessionHelpers.getStatusAndToken();
  var date = new Date();
  date.setDate(date.getDate() + 1);
  const [loadingSave, setLoadingSave] = useState(false);
  const { t } = useContext(Il8Context);
  const { state, dispatch } = useContext(GlobalContext);

  const alertRef = useRef(null);
  const [postCode, setPostCode] = useState("");
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);
  const addressRef = useRef(null);
  const validateRef = useRef(null);
  const [town, setTwon] = useState("");
  const [street, setStreet] = useState("");
  const [organisation, setOrganisation] = useState("");
  const streetRef = useRef(null);
  const townRef = useRef(null);
  const [InpCounty, setInpCounty] = useState("");
  const [countrySelection, setCountrySelection] = useState("");
  const countryRef = useRef(null);

  useEffect(() => {
    if (state?.countrys?.length > 0 && state?.acObj?.defaultShippingAddress.country) {
      let countryId = state?.countrys?.find((item) => item.name === state?.acObj?.defaultShippingAddress.country)?.id || "";
      setCountrySelection(countryId);
    }
    setOrganisation(state?.acObj?.defaultShippingAddress?.organisation || "");
    setStreet(state?.acObj?.defaultShippingAddress?.street || "");
    setTwon(state?.acObj?.defaultShippingAddress?.town || "");
    setInpCounty(state?.acObj?.defaultShippingAddress?.county || "");
    setPostCode(state?.acObj?.defaultShippingAddress?.postCode || "");
    // eslint-disable-next-line
  }, [state?.countrys, state?.acObj?.defaultShippingAddress.country]);

  /**
   * 
   * @returns This function can update addres details in api.
   */
  const addAddresss = async () => {
    if (countryValidation(countrySelection, countryRef) === false) return;
    if (streetValidation(street, streetRef) === false) return;
    if (townValidation(town, townRef) === false) return;
    if (postCodeValidation(postCode, validateRef) === false) return;

    setLoadingSave(true);
    const dataObj = {
      organisation,
      street,
      town,
      county: InpCounty,
      postCode,
      countryId: countrySelection,
    };

    await callApi("updateShippingAddress", { token, alertRef }, dataObj)
      .then(({ res, sCode }) => {
        if (sCode === 202 || sCode === 200) {
          res?.body?.result?.country && dispatch({
            type: globalActionsTypes.setAccountObj,
            data: {...state?.acObj, defaultShippingAddress : { ...state?.acObj.defaultShippingAddress ,...res?.body?.result}},
          });
          alertRef.current?.onSuccess({
            body: <T strProp="shippingAddressSuccess" />,
            btnTxt: t("BtnOK"),
            goBack: true,
          });
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoadingSave(false));
  };

  return (
    <>
      <Layout title="titleEditDeliveryAddress" id="edit-delivery-address">
        {/* <div className="complete-page" /> */}
        <div className="API-panding-page" />
        <section
          className="editda edit-add-book-section">
          <BackCard Title="shippingAddress" Path={-1} />

          <div className="edit-add-book-main-div">
            <CountryInp
              token={token}
              countrySelection={countrySelection}
              setCountrySelection={setCountrySelection}
              countryRef={countryRef}
            />
            <LookUp
              setPostCode={setPostCode}
              postCode={postCode}
              loading={loading}
              addressRef={addressRef}
              contactRefP={validateRef}
              town={town}
              setTwon={setTwon}
              street={street}
              setStreet={setStreet}
              organisation={organisation}
              setOrganisation={setOrganisation}
              contactRefS={streetRef}
              contactRefT={townRef}
              setInpCounty={setInpCounty}
              InpCounty={InpCounty}
              setCountrySelection={setCountrySelection}
              isAddAddress={false}
            />
            <div className="edit-add-book-add-btn">
              <ProductBlueBtn
                isloading={loadingSave}
                BtnTilte="quotesave"
                onClick={addAddresss}
              />
            </div>
          </div>
        </section>
        <AlertPopup ref={alertRef} />
      </Layout>
    </>
  )
}

export default ShippingAddress
